import { render, staticRenderFns } from "./v-autocomplete-custom.vue?vue&type=template&id=060f550a"
import script from "./v-autocomplete-custom.vue?vue&type=script&lang=js"
export * from "./v-autocomplete-custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports